import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { EditOffOutlined } from "@mui/icons-material"

import { HelveticaBold } from "common/typographies.js"
import { PriceInput } from "common/inputs"

const PartTableInput = ({
  partida = {},
  disabled = false,
  name = "name",
  onBlur = (name, value) => {},
  onClick = () => {},
  onFocus = e => {
    e.target.select()
  },
  symbol = "€",
  title = "Title",
  green = false,
  yellow = false,
  red = false,
  value = 0,
  isOutlined = false,
  outlined = () => {},
  decimals = 2,
  wrapInTd = true,
}) => {
  const [onEdit, setOnEdit] = useState(false)
  const [inputValue, setInputValue] = useState(value)

  const handleChange = event => {
    setOnEdit(true)
    setInputValue(event.target.value)
  }

  const handleCommit = value => {
    onBlur(name, value)
    setOnEdit(false)
  }

  const handleBlur = event => {
    handleCommit(event.target.value)
  }

  const handleKeyDown = event => {
    if (event.key === "Enter") {
      event.preventDefault()
      handleCommit(event.target.value)
    }
  }

  useEffect(() => {
    const num = Number(value)
    setInputValue(!isNaN(num) ? num.toFixed(decimals) : (0).toFixed(decimals))
  }, [partida, value, decimals])

  const cellBackground = {
    backgroundColor: red
      ? "#79211F"
      : yellow
        ? "#FCFC99"
        : green
          ? "#8edb91"
          : disabled
            ? "#E4E4E4"
            : "transparent",
  }

  const inner = (
    <div
      className="inline"
      style={{
        width: "100%",
        minHeight: wrapInTd ? undefined : "100%",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        textAlign: "center",
        ...(!wrapInTd ? cellBackground : {}),
      }}
    >
      <PriceInput
        type="number"
        name={name}
        onClick={onClick}
        onFocus={onFocus}
        onWheel={e => e.currentTarget.blur()}
        style={{
          width: "70%",
          position: "relative",
          fontSize: "14px",
          textAlign: "center",
          backgroundColor: "transparent",
          color: red ? "#FFFFFF" : "#414141",
        }}
        disabled={disabled}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        value={
          onEdit
            ? inputValue
            : (() => {
                const num = Number(inputValue)
                return !isNaN(num)
                  ? num.toFixed(decimals)
                  : (0).toFixed(decimals)
              })()
        }
      />
      <HelveticaBold
        style={{
          color: red ? "#FFFFFF" : "#414141",
          fontSize: "14px",
          textAlign: "center",
        }}
      >
        {symbol}
      </HelveticaBold>
      {isOutlined && (
        <EditOffOutlined
          onClick={outlined}
          style={{
            position: "absolute",
            fontSize: "15px",
            right: "5px",
            color: "#414141",
            top: "10px",
            cursor: "pointer",
          }}
        />
      )}
    </div>
  )

  if (!wrapInTd) {
    return inner
  }

  return <td style={cellBackground}>{inner}</td>
}

PartTableInput.propTypes = {
  disabled: PropTypes.bool,
  green: PropTypes.bool,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  partida: PropTypes.object,
  red: PropTypes.bool,
  symbol: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.number,
  yellow: PropTypes.bool,
  isOutlined: PropTypes.bool,
  outlined: PropTypes.func,
  decimals: PropTypes.number,
  wrapInTd: PropTypes.bool,
}

export { PartTableInput }
